import { render, staticRenderFns } from "./ReviewCardComments.vue?vue&type=template&id=80517550&scoped=true&"
import script from "./ReviewCardComments.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardComments.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardComments.vue?vue&type=style&index=0&id=80517550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80517550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80517550')) {
      api.createRecord('80517550', component.options)
    } else {
      api.reload('80517550', component.options)
    }
    module.hot.accept("./ReviewCardComments.vue?vue&type=template&id=80517550&scoped=true&", function () {
      api.rerender('80517550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardComments.vue"
export default component.exports